export const SAVED_VIEWS_STALE_TIME: number = 60 * 1000
